import { PayloadAction } from '@reduxjs/toolkit';
import { Event, ScheduleState } from '../state';

export const fetchEvents = (state: ScheduleState, action: PayloadAction<Event[]>) => {
    state.events = action.payload;
}

export const addEvent = (state: ScheduleState, action: PayloadAction<Event>) => {
    state.events.push(action.payload);
    state.dialog.data = null;
}

export const updateEvent = (state: ScheduleState, action: PayloadAction<Event>) => {
    state.events = state.events.map(event => event.id === action.payload.id ? action.payload : event);
    state.dialog.data = null;
}

export const deleteEvent = (state: ScheduleState, action: PayloadAction<string>) => {
    state.events = state.events.filter(event => event.id !== action.payload);
    state.dialog.data = null;
}
